import type React from 'react';

import { ThemeProvider } from '@change/ds-core-ui';

import { useImpactStoryPageData } from '#src/app/pages/impactStory/pageContext';

import { PageBody } from '../components/PageBody';

import { useTrackPageView } from './hooks/useTrackPageView';

export const Layout: React.FC = () => {
	const {
		data: {
			petition: { slug },
		},
	} = useImpactStoryPageData();

	useTrackPageView(slug);

	return (
		<ThemeProvider>
			<PageBody />
		</ThemeProvider>
	);
};
